import React, { useEffect, useState } from 'react';

/**
 * FaviconSerpReport: Gürgençler ve Yenilio'nun organik arama sonuçlarında marka
 * ikonunun neden görünmediğine dair teknik teşhis + 18 adımlık aksiyon planı.
 * Route: /r/gurgencler-yenilio-favicon (sidebar YOK, tam ekran belge)
 *
 * İki markayı birden kapsıyor, o yüzden HupalupaYoutubeReport'taki gibi
 * `allowBrandIds` çoklu: Gürgençler (526a6404…) + Yenilio (c7778265…).
 *
 * İçerik statik — API çağrısı yok. Bulgular 14 Ağu 2026'da canlı sistem üzerinde
 * ölçüldü (Cloudflare 403'leri, favicon dosya ölçüleri, CDN başlıkları) ve HTML'e
 * gömülü.
 *
 * 🔑 Rapor müşteriye PDF olarak gidiyor. İçindeki "PDF olarak kaydet" düğmesi
 * iframe'in kendi belgesinde `window.print()` çağırır — tarayıcı yalnızca raporu
 * basar, dashboard'u değil. Dış sayfadan Ctrl+P ise iframe'i kırpar, o yüzden
 * düğme belgenin İÇİNDE duruyor; kaldırma.
 *
 * HTML modülü ~70KB (iki favicon ve Glowytics logosu data URI olarak gömülü).
 * Ana bundle'da işi yok, dinamik import ile yükleniyor.
 */
export default function FaviconSerpReport() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./faviconSerpReportHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#0B1020">Rapor yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini raporun kendi zeminiyle aynı (--ground açık tema) — beyaz/siyah flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#F6F7FB' }} />;

  return (
    <iframe
      title="Gürgençler & Yenilio · Kayıp Favicon Teşhisi"
      srcDoc={html}
      style={fill}
    />
  );
}
